<template>
  <div class="bills-by-registry-page">
    <div class="page__header">
      <div class="page__title">
        <router-link :to="backLinkRoute" class="page__back-link">
          <arrow-button
            class="page__back-link-icon"
            :rotated180="true"
          ></arrow-button>
        </router-link>
        <div class="page__title-text">
          {{
            billsRegistry.name ||
            $t('payouts.by-registry.registry-page.title-loading')
          }}
        </div>
      </div>
    </div>
    <loader v-if="isDataLoading"></loader>
    <component
      v-else
      :is="subPageComponent"
      :bills-registry="billsRegistry"
      :bills-registry-positions="billsRegistryPositions"
      @refresh="handleRefresh"
    ></component>
  </div>
</template>

<script>
import responsiveMixin from '@vue-app/mixins/responsive-mixin'

import { mapState } from 'vuex'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import Loader from '@vue-app/components/base/Loader.vue'
import BillRegistryCreated from '@vue-app/views/company/Bills/SubPages/BillRegistryCreated.vue'
import BillsRegistryMain from '@vue-app/views/company/Bills/ByRegistry/BillsRegistryMain.vue'
export default {
  name: 'BillsRegistry',
  components: {
    Loader,
    ArrowButton,
    PrimaryButton,
    BillRegistryCreated,
    BillsRegistryMain,
  },
  props: {
    id: {
      type: [String, Number],
    },
    billsRegistryId: [String, Number],
  },
  mixins: [responsiveMixin],
  data() {
    return {
      billsRegistry: {},
      billsRegistryPositions: {},
      isDataLoading: true,
    }
  },

  computed: {
    ...mapState(['selectedCompany']),
    backLinkRoute() {
      return this.$router.resolve({
        name: 'company-bills',
        params: {
          id: this.selectedCompany,
        },
        hash: '#by-registry',
      }).href
    },
    subPageComponent() {
      const validStatuses = ['created', 'processing', 'processed']

      return validStatuses.includes(this.billsRegistry?.status)
        ? 'BillRegistryCreated'
        : 'BillsRegistryMain'
    },
  },
  created() {
    this.startupPage()
  },
  methods: {
    async startupPage() {
      this.isDataLoading = true
      await this.loadBillsRegistry()
      this.isDataLoading = false
    },
    async loadBillsRegistry() {
      this.billsRegistry =
        (await CompaniesApi.getBillsRegistryById(this.id, this.billsRegistryId))
          .data || {}

      await this.loadBillsRegistryPositions()
    },
    async loadBillsRegistryPositions() {
      this.billsRegistryPositions = this.billsRegistry.bills
    },
    handleRefresh() {
      this.startupPage()
    },
  },
}
</script>

<style lang="scss" scoped>
.bills-by-registry-page {
  margin-top: 30px;
  .page {
    &__header {
      margin-bottom: 30px;
    }
  }

  .transactions-page-controls {
    margin-top: 30px;
  }

  .payouts-registries-table {
    margin-top: 10px;
  }
}
</style>
